import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 16a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-12","key":"svg-0"}],["path",{"d":"M5 20l14 0","key":"svg-1"}]]

/**
 * IconCloudFog
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2xvdWQtZm9nIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik03IDE2YTQuNiA0LjQgMCAwIDEgMCAtOWE1IDQuNSAwIDAgMSAxMSAyaDFhMy41IDMuNSAwIDAgMSAwIDdoLTEyIiAvPgogIDxwYXRoIGQ9Ik01IDIwbDE0IDAiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/cloud-fog
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCloudFog = createReactComponent('outline', 'cloud-fog', 'CloudFog', __iconNode);

export default IconCloudFog;